import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the ProvidersFormatoPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formato',
})
export class ProvidersFormatoPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, tasa,) {
    if(value){
      let val
      if(window.localStorage.moneda === 'BS'){
        val = parseFloat(value)
        // val = parseFloat(value) * parseFloat(window.localStorage.cambio)
      }else{
        if (tasa) {
          val = parseFloat((parseFloat(value) / parseFloat(tasa)).toFixed(2))
        } else {
          // val = parseFloat(value) / parseFloat(window.localStorage.cambio)
          val = parseFloat((parseFloat(value) / parseFloat(window.localStorage.cambio)).toFixed(2))
        }
      }
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/providers-formato/providers-formato.ts